// extracted by mini-css-extract-plugin
export default {"page":"_404_page__cH3Li","logo":"_404_logo__ONsVC","wrapper":"_404_wrapper__8Q2ll","content":"_404_content__23tg9","image":"_404_image__fW3U6","button":"_404_button__ko-Ow"};